export abstract class ObjectUtils {
  public static findValue(obj: any, path: string): any {
    return path.split('.').reduce((o, key) => {
      return o && o[key] ? o[key] : null;
    }, obj);
  }
}
